import { useState, useEffect } from 'react'
import TemplateSelector from '../components/TemplateSelector'
import ManualInput from '../components/ManualInput'
import CSVUploader from '../components/CSVUploader'
import DesignPreview from '../components/DesignPreview'
import { authService } from '../services/auth'
import '../styles/Dashboard.css'

export default function Dashboard() {
  const [currentMode, setCurrentMode] = useState(null)
  const [previewData, setPreviewData] = useState(null)
  const [user, setUser] = useState(null)

  useEffect(() => {
    const currentUser = authService.getCurrentUser()
    setUser(currentUser)
  }, [])

  return (
    <div className="dashboard">
      {!currentMode ? (
        <>
          <div className="dashboard-hero">
            <div className="hero-gradient"></div>
            <div className="hero-content">
              <h2>Welcome back, {user?.username || 'Designer'}!</h2>
              <p>Create stunning designs in seconds with our automated platform</p>
            </div>
          </div>
          <div className="dashboard-container">
            <TemplateSelector onSelect={setCurrentMode} />
          </div>
        </>
      ) : (
        <div className="dashboard-container">
          <div className="mode-container">
            <button className="back-btn" onClick={() => {
              setCurrentMode(null)
              setPreviewData(null)
            }}>
              ← Back
            </button>

            {currentMode === 'manual' && (
              <ManualInput onDesignCreated={setPreviewData} />
            )}

            {currentMode === 'bulk' && (
              <CSVUploader onUploadComplete={setPreviewData} />
            )}
          </div>
        </div>
      )}

      {previewData && (
        <DesignPreview data={previewData} onClose={() => setPreviewData(null)} />
      )}
    </div>
  )
}
